import { mergeAll } from 'ramda';

import state from './state';
import actions from './guideline-model/actions';
import mutations from './guideline-model/mutations';
import valuationModelActions from './valuation-model/actions';
import valuationModelMutations from './valuation-model/mutations';

export default {
	mutations: mergeAll([mutations, valuationModelMutations]),
	actions: mergeAll([actions, valuationModelActions]),
	state,
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/index.js